/* @jsxImportSource react */

import React from 'react';

import { cn } from '../../utils/cn/cn';

import { RatingStar } from './RatingStar';
import { getStarFillAmount } from './getStarFillAmount';

export type RatingStarsProps = {
  totalStars?: number;
  ratingValue: number;
};

export const RatingStars: React.FC<RatingStarsProps & React.HTMLAttributes<HTMLDivElement>> = ({
  totalStars = 5,
  ratingValue,
  className,
  ...props
}) => (
  <div {...props} className={cn('inline-flex gap-0.5', className)}>
    {Array.from({ length: totalStars }, (_, index) => index + 1).map((star) => (
      <RatingStar key={star} fillPercentage={getStarFillAmount(star, ratingValue)} />
    ))}
  </div>
);
